import {
  GET_CONTACT_US_BEGIN,
  GET_CONTACT_US_SUCCESS,
  GET_CONTACT_US_ERROR,
  GET_REGISTER_FORM_BEGIN,
  GET_REGISTER_FORM_SUCCESS,
  GET_REGISTER_FORM_ERROR,
  GET_REGISTER_DETAIL_EXPO_BEGIN,
  GET_REGISTER_DETAIL_EXPO_SUCCESS,
  GET_REGISTER_DETAIL_EXPO_ERROR,
  POST_EXPO_CONTACT_US_BEGIN,
  POST_EXPO_CONTACT_US_SUCCESS,
  POST_EXPO_CONTACT_US_ERROR,
  GET_VISITOR_FORMAT_BEGIN,
  GET_VISITOR_FORMAT_SUCCESS,
  GET_VISITOR_FORMAT_ERROR,
  SUBMIT_DOMESTIC_VISITOR_BEGIN,
  SUBMIT_DOMESTIC_VISITOR_SUCCESS,
  SUBMIT_DOMESTIC_VISITOR_ERROR,
  SUBMIT_INTERNATIONAL_VISITOR_BEGIN,
  SUBMIT_INTERNATIONAL_VISITOR_SUCCESS,
  SUBMIT_INTERNATIONAL_VISITOR_ERROR,
  SUBMIT_EXHIBITOR_BEGIN,
  SUBMIT_EXHIBITOR_SUCCESS,
  SUBMIT_EXHIBITOR_ERROR,
} from "../utils/action";

const Form_reducer = (state, action) => {
  switch (action.type) {
    case GET_CONTACT_US_BEGIN:
      return { ...state, contact_us_loading: true };

    case GET_CONTACT_US_SUCCESS:
      return {
        ...state,
        contact_us_loading: false,
        contact_us_data: action.payload,
      };

    case GET_CONTACT_US_ERROR:
      return { ...state, contact_us_loading: false };

    case POST_EXPO_CONTACT_US_BEGIN:
      return { ...state, expo_contact_us_loading: true };

    case POST_EXPO_CONTACT_US_SUCCESS:
      return {
        ...state,
        expo_contact_us_loading: false,
      };

    case POST_EXPO_CONTACT_US_ERROR:
      return { ...state, expo_contact_us_loading: false };

    case GET_REGISTER_FORM_BEGIN:
      return { ...state, register_form_loading: true };

    case GET_REGISTER_FORM_SUCCESS:
      return {
        ...state,
        register_form_loading: false,
        register_form_data: action.payload,
      };

    case GET_REGISTER_FORM_ERROR:
      return { ...state, register_form_loading: false };

    case GET_REGISTER_DETAIL_EXPO_BEGIN:
      return {
        ...state,
        register_detail_expo_loading: true,
        register_detail_expo_data: {},
      };

    case GET_REGISTER_DETAIL_EXPO_SUCCESS:
      return {
        ...state,
        register_detail_expo_loading: false,
        register_detail_expo_data: action.payload,
      };

    case GET_REGISTER_DETAIL_EXPO_ERROR:
      return { ...state, register_detail_expo_loading: false };

    case GET_VISITOR_FORMAT_BEGIN:
      return {
        ...state,
        visitor_format_loading: true,
        visitor_format_data: {},
      };

    case GET_VISITOR_FORMAT_SUCCESS:
      return {
        ...state,
        visitor_format_loading: false,
        visitor_format_data: action.payload,
      };

    case GET_VISITOR_FORMAT_ERROR:
      return { ...state, visitor_format_loading: false };

    case SUBMIT_DOMESTIC_VISITOR_BEGIN:
      return { ...state, submit_domestic_visitor_loading: true };

    case SUBMIT_DOMESTIC_VISITOR_SUCCESS:
      return {
        ...state,
        submit_domestic_visitor_loading: false,
      };

    case SUBMIT_DOMESTIC_VISITOR_ERROR:
      return { ...state, submit_domestic_visitor_loading: false };

    case SUBMIT_INTERNATIONAL_VISITOR_BEGIN:
      return { ...state, submit_international_visitor_loading: true };

    case SUBMIT_INTERNATIONAL_VISITOR_SUCCESS:
      return {
        ...state,
        submit_international_visitor_loading: false,
      };

    case SUBMIT_INTERNATIONAL_VISITOR_ERROR:
      return { ...state, submit_international_visitor_loading: false };

    case SUBMIT_EXHIBITOR_BEGIN:
      return { ...state, submit_exhibitor_loading: true };

    case SUBMIT_EXHIBITOR_SUCCESS:
      return {
        ...state,
        submit_exhibitor_loading: false,
      };

    case SUBMIT_EXHIBITOR_ERROR:
      return { ...state, submit_exhibitor_loading: false };

    default:
      return state;
  }
};

export default Form_reducer;
